import actionType from '../actions/computer/actionType';

export interface IguestInfo {
  id: number;
  brand?: string; // 品牌
  driverUrl?: string; // 驱动下载地址
  equipmentModel?: string; // 设备型号
  identificationCode?: string; // 硬件识别码
  status?: number; // 是否启用
}

const initialState: any = {
  searchParam: { pageNum: 1, pageSize: 12, useStatus: '' },
  searchRes: {
    computerList: [],
    total: 0,
  },
  historyParam: { pageNum: 1, pageSize: 50, total: 0 },
  usageRecordList: [],
  usageRecordListLoading: false,
  computerListLoading: false,
  idCardListLoading: false,
  recordListLoading: false,
  recordList: [],
  idCardList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_SEARCH_RES:
      return {
        ...state,
        searchRes: {
          ...state.searchRes,
          ...action.payload,
        },
      };
    // 更新搜索内容
    case actionType.UPDATE_SEARCH_PARAM:
      return {
        ...state,
        searchParam: {
          ...state.searchParam,
          [action.payload.field]: action.payload.value,
        },
      };
    case actionType.UPDATE_RECORD_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_USAGE_RECORD_HISTORY:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.UPDATE_ID_CARD_LIST:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
